export default "__VITE_ASSET__BBq8NKJY__"